/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseError } from '../../../shared/errors/Errors';
import { ClientTenantAndAppVariantEntry } from '@DigitaleDoerfer/digitale-doerfer-api';

export const GET_APP_CONFIGS_REQUEST = 'GET_APP_CONFIGS_REQUEST';
export const GET_APP_CONFIGS_SUCCESS = 'GET_APP_CONFIGS_SUCCESS';
export const GET_APP_CONFIGS_FAILURE = 'GET_APP_CONFIGS_FAILURE';

export interface GetAppConfigsRequestAction {
	type: typeof GET_APP_CONFIGS_REQUEST;
}

export interface GetAppConfigsSuccessAction {
	type: typeof GET_APP_CONFIGS_SUCCESS;
	appConfigs: ClientTenantAndAppVariantEntry[];
}

export interface GetAppConfigsFailureAction {
	type: typeof GET_APP_CONFIGS_FAILURE;
	error: BaseError | null;
}

export type AppConfigActionTypes = GetAppConfigsRequestAction | GetAppConfigsSuccessAction | GetAppConfigsFailureAction;
